import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PageTitle} from '../../_metronic/layout/core'
import TopBarProgress from 'react-topbar-progress-indicator'
import {HomeWrapper} from '../pages/home/HomeWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import Dashboard from '../pages/dashboard/Dashboard'
import Users from '../pages/users/Users'
import CompanyTabs from '../pages/company/CompanyTabs'
import GeneralMenu from '../pages/generalmenu/GeneralMenu'
import NPSList from '../pages/nps/NPSList'
import NPSCreator from '../pages/nps/NPSCreator'
import API from '../pages/api/API'
import PowerBITest from '../pages/PowerBITest'
import AlertCreation from '../pages/alerts/AlertCreation'
import AlertMonitoring from '../pages/alerts/AlertMonitoring'
import PedidosReport from '../pages/reports/PedidosReport'
import PromosReport from '../pages/reports/PromosReport'
import NotaFiscalReport from '../pages/reports/NotaFiscalReport'
import CadastroLojistasReport from '../pages/reports/CadastroLojistasReport'
import CadastroVendedorReport from '../pages/reports/CadastroVendedorReport'
import ApuracaoReport from '../pages/reports/ApuracaoReport'
import SelloutReport from '../pages/reports/SelloutReport'
import HistoricoPrecoEstoqueReport from '../pages/reports/HistoricoPrecoEstoqueReport'
import DistribuidorPrioritarioReport from '../pages/reports/DistribuidorPrioritarioReport'
import UltimoPrecoEstoqueReport from '../pages/reports/UltimoPrecoEstoqueReport'
import ReportLojasVendaPremiada from '../pages/reports/ReportLojasVendaPremiada'
import LojistasReport from '../pages/reports/LojistasReport'
import CuponsReport from '../pages/reports/CuponsReport'
import LojasRelacionamentoReport from '../pages/reports/LojasRelacionamentoReport'
import LogsScreen from '../pages/logs/LogsScreen'
import {SuperAdminAnalyticsRoute} from '../pages/analytics/AnalyticsPage'

import ReportPoliticaPreco from '../pages/reports/ReportPoliticaPreco'
import {SimuladorCampanha} from '../pages/sales/simulador-campanha'
import {CopilotoDoVendedorPesquisa} from '../pages/copiloto-do-vendedor/CopilotoDoVendedorPesquisa'
import {CopilotoDoVendedorVendaAI} from '../pages/copiloto-do-vendedor/CopilotoDoVendedorVendaAI'
import {CopilotoDoVendedorLojista} from '../pages/copiloto-do-vendedor/CopilotoDoVendedorLojista'

import {DashboardPage} from '../pages/sellers/general'
import {ProductsPage} from '../pages/sellers/produtos/ProductsPage'
import {ImportPage} from '../pages/sellers/importar-dados/ImportPage'
import {SettingsPage} from '../pages/sellers/config/SettingsPage'
import {SuppliersPage} from '../pages/sellers/fornecedores/SuppliersPage'
import {TablePage} from '../pages/sellers/reposicao/TablePage'
import {PurchaseOrderPage} from '../pages/sellers/pedido-compra/PurchaseOrderPage'
import {OrdersPage} from '../pages/sellers/pedidos/OrdersPage'
import {OrderDetailPage} from '../pages/sellers/pedidos/OrderDetailPage'
import {SellerUsersPage} from '../pages/sellers/usuarios/SellerUsersPage'
import {HistoryPage} from '../pages/sellers/historico/HistoryPage'
import {UserMenuProvider, useUsermenuData} from '../hooks/useUserMenuData'

const SellerRoute: FC<WithChildren & {title: string}> = ({children, title}) => (
  <>
    <PageTitle>{title}</PageTitle>
    {children}
  </>
)

const HomeEntryRoute = () => {
  const {isFetching, isLojistasOnly} = useUsermenuData()
  if (isFetching) return null
  return isLojistasOnly ? <Navigate to='/lojistas/geral' replace /> : <HomeWrapper />
}

const AuthEntryRoute = () => {
  const {isFetching, isLojistasOnly} = useUsermenuData()
  if (isFetching) return null
  return <Navigate to={isLojistasOnly ? '/lojistas/geral' : '/home'} replace />
}

const PrivateRoutesContent = () => {
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<AuthEntryRoute />} />
        {/* Pages */}
        <Route path='home' element={<HomeEntryRoute />} />
        <Route path='/' element={<HomeEntryRoute />} />
        <Route path=':dashboardId/dashboard' element={<Dashboard />} />
        <Route path=':dashboardId/api' element={<API />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='powerbi' element={<PowerBITest />} />
        <Route path='users' element={<Users />} />
        <Route path='companys' element={<CompanyTabs />} />
        <Route path='nps' element={<NPSList />} />
        <Route path='nps/create' element={<NPSCreator npsId={null} onBack={() => {}} />} />
        <Route path='nps/edit/:id' element={<NPSCreator npsId={null} onBack={() => {}} />} />
        <Route path='generalmenu' element={<GeneralMenu />} />
        <Route path='logs' element={<LogsScreen />} />
        <Route path='analytics' element={<SuperAdminAnalyticsRoute />} />
        <Route path='analytics/:section' element={<SuperAdminAnalyticsRoute />} />

        <Route path='alerts/list' element={<AlertMonitoring />} />
        <Route path='alerts/new' element={<AlertCreation />} />
        <Route path='alerts/:alertId' element={<AlertCreation />} />

        <Route path='reports/pedidos' element={<PedidosReport className='' />} />
        <Route path='reports/promos' element={<PromosReport className='' />} />
        <Route path='reports/notafiscal' element={<NotaFiscalReport className='' />} />
        <Route path='reports/cadastro_lojistas' element={<CadastroLojistasReport className='' />} />
        <Route
          path='reports/cadastro_vendedores'
          element={<CadastroVendedorReport className='' />}
        />
        <Route path='reports/apuracao' element={<ApuracaoReport className='' />} />
        <Route path='reports/sellout' element={<SelloutReport className='' />} />
        <Route
          path='reports/historico_preco_estoque'
          element={<HistoricoPrecoEstoqueReport className='' />}
        />
        <Route
          path='reports/distribuidor_prioritario'
          element={<DistribuidorPrioritarioReport className='' />}
        />
        <Route
          path='reports/ultimo_preco_estoque'
          element={<UltimoPrecoEstoqueReport className='' />}
        />
        <Route path='reports/lojistas' element={<LojistasReport className='' />} />
        <Route path='reports/cupons' element={<CuponsReport className='' />} />
        <Route path='reports/politica_preco' element={<ReportPoliticaPreco className='' />} />
        <Route
          path='reports/lojas_venda_premiada'
          element={<ReportLojasVendaPremiada className='' />}
        />

        <Route
          path='reports/lojas_quase_churn'
          element={<LojasRelacionamentoReport key='lojas_quase_churn' type='lojas_quase_churn' />}
        />
        <Route
          path='reports/lojas_quase_fidelizadas'
          element={
            <LojasRelacionamentoReport
              key='lojas_quase_fidelizadas'
              type='lojas_quase_fidelizadas'
            />
          }
        />

        <Route path='sales/simulador-campanha' element={<SimuladorCampanha />} />

        <Route
          path='lojistas/geral'
          element={
            <SellerRoute title='Visão Geral do Estoque'>
              <DashboardPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/importar'
          element={
            <SellerRoute title='Importar Dados'>
              <ImportPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/historico'
          element={
            <SellerRoute title='Histórico de Estoque'>
              <HistoryPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/fornecedores'
          element={
            <SellerRoute title='Fornecedores'>
              <SuppliersPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/configuracoes'
          element={
            <SellerRoute title='Configurações'>
              <SettingsPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/tabela-reposicao'
          element={
            <SellerRoute title='Tabela de Reposição'>
              <TablePage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/pedido-compra'
          element={
            <SellerRoute title='Pedido de Compra'>
              <PurchaseOrderPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/pedidos'
          element={
            <SellerRoute title='Pré-pedidos e Pedidos'>
              <OrdersPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/produtos'
          element={
            <SellerRoute title='Produtos'>
              <ProductsPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/pedidos/:orderId'
          element={
            <SellerRoute title='Detalhes do Pedido'>
              <OrderDetailPage />
            </SellerRoute>
          }
        />
        <Route
          path='lojistas/usuarios'
          element={
            <SellerRoute title='Usuários'>
              <SellerUsersPage />
            </SellerRoute>
          }
        />

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />

        <Route path='/copiloto-do-vendedor/pesquisa' element={<CopilotoDoVendedorPesquisa />} />
        <Route path='/copiloto-do-vendedor/lojista/:cnpj' element={<CopilotoDoVendedorLojista />} />
        <Route path='/copiloto-do-vendedor/venda-ai' element={<CopilotoDoVendedorVendaAI />} />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const PrivateRoutes = () => (
  <UserMenuProvider>
    <PrivateRoutesContent />
  </UserMenuProvider>
)

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
